import React from 'react';
import Icon from '../../../components/AppIcon';

const ConsultationHeader = ({ patientName, reportPeriod, onPeriodChange }) => {
  return (
    <div className="bg-gradient-to-r from-indigo-700 to-indigo-900 text-white px-6 py-6 rounded-t-2xl">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
            <Icon name="Stethoscope" size={22} className="text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold tracking-tight">Consultation Snapshot</h2>
            <p className="text-indigo-200 text-sm">Ready for your doctor appointment</p>
          </div>
        </div>
        <div className="flex items-center gap-2 bg-white/10 rounded-xl px-3 py-2">
          <Icon name="Clock" size={14} className="text-indigo-200" />
          <span className="text-xs text-indigo-200">~30 sec read</span>
        </div>
      </div>
      <div className="mt-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-xs text-indigo-300 uppercase tracking-wide font-medium mb-1">Patient</p>
          <p className="text-lg font-semibold">{patientName || 'Patient'}</p>
        </div>
        <div>
          <p className="text-xs text-indigo-300 uppercase tracking-wide font-medium mb-1">Report Period</p>
          <div className="flex gap-2">
            {[7, 14, 30]?.map(days => (
              <button
                key={days}
                onClick={() => onPeriodChange(days)}
                className={`px-3 py-1.5 rounded-lg text-sm font-semibold transition-colors ${
                  reportPeriod === days
                    ? 'bg-white text-indigo-700' :'bg-white/20 text-white hover:bg-white/30'
                }`}
              >
                {days}d
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationHeader;
